"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var Transition_1 = __importDefault(require("../Transition"));
var ContextMenu_less_1 = __importDefault(require("./ContextMenu.less"));
var PADDING = 8;
var ContextMenu = function (_a) {
    var children = _a.children, on = _a.on, autoClose = _a.autoClose, lock = _a.lock;
    var _b = (0, react_1.useState)(false), active = _b[0], setActive = _b[1];
    var _c = (0, react_1.useState)([0, 0]), position = _c[0], setPosition = _c[1];
    var _d = (0, react_1.useState)([0, 0]), containerSize = _d[0], setContainerSize = _d[1];
    var _e = (0, react_1.useState)(null), triggerRect = _e[0], setTriggerRect = _e[1];
    var ref = (0, react_1.useCallback)(function (element) {
        element && setContainerSize([element.offsetWidth, element.offsetHeight]);
    }, []);
    var style = (0, react_1.useMemo)(function () {
        var _a = [window.innerWidth, window.innerHeight], viewportWidth = _a[0], viewportHeight = _a[1];
        var containerWidth = containerSize[0], containerHeight = containerSize[1];
        var x;
        var y;
        if (lock && triggerRect) {
            switch (lock) {
                case 'top':
                    x = triggerRect.left;
                    y = triggerRect.top - containerHeight;
                    break;
                case 'bottom':
                    x = triggerRect.left;
                    y = triggerRect.bottom;
                    break;
                case 'left':
                    x = triggerRect.left - containerWidth;
                    y = triggerRect.top;
                    break;
                case 'right':
                    x = triggerRect.right;
                    y = triggerRect.top;
                    break;
            }
        }
        else {
            x = position[0], y = position[1];
        }
        var left = Math.max(PADDING, Math.min(x + containerWidth > viewportWidth - PADDING ? x - containerWidth : x, viewportWidth - containerWidth - PADDING));
        var top = Math.max(PADDING, Math.min(y + containerHeight > viewportHeight - PADDING ? y - containerHeight : y, viewportHeight - containerHeight - PADDING));
        return { top: top, left: left };
    }, [position, containerSize, lock, triggerRect]);
    var close = (0, react_1.useCallback)(function () {
        setActive(false);
    }, []);
    var stopPropagation = (0, react_1.useCallback)(function (event) {
        event.stopPropagation();
    }, []);
    var onContextMenu = (0, react_1.useCallback)(function (event) {
        if (event.shiftKey)
            return;
        event.preventDefault();
        if (lock) {
            var target = event.currentTarget;
            setTriggerRect(target.getBoundingClientRect());
        }
        else {
            setPosition([event.clientX, event.clientY]);
        }
        setActive(true);
    }, [lock]);
    var containerOnMouseDown = (0, react_1.useCallback)(function (event) {
        if (event.button !== 2 && !event.ctrlKey)
            close();
    }, [close]);
    var containerOnContextMenu = (0, react_1.useCallback)(function (event) {
        if (event.shiftKey)
            return;
        event.preventDefault();
        if (!lock && event.target === event.currentTarget) {
            setPosition([event.clientX, event.clientY]);
        }
    }, [lock]);
    var handleKeyDown = (0, react_1.useCallback)(function (event) { return event.key === 'Escape' && close(); }, [close]);
    var onClick = (0, react_1.useCallback)(function (event) {
        event.stopPropagation();
        autoClose && close();
    }, [autoClose, close]);
    (0, react_1.useEffect)(function () {
        on.forEach(function (ref) { return ref.current && ref.current.addEventListener('contextmenu', onContextMenu); });
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            on.forEach(function (ref) { return ref.current && ref.current.removeEventListener('contextmenu', onContextMenu); });
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [on, onContextMenu, handleKeyDown]);
    return (0, react_dom_1.createPortal)((react_1.default.createElement(Transition_1.default, { when: active, name: 'fade' },
        react_1.default.createElement("div", { className: ContextMenu_less_1.default['context-menu-container'], onMouseDown: containerOnMouseDown, onContextMenu: containerOnContextMenu, onTouchStart: close },
            react_1.default.createElement("div", { ref: ref, className: ContextMenu_less_1.default['context-menu'], style: style, onMouseDown: stopPropagation, onTouchStart: stopPropagation, onClick: onClick }, children)))), document.body);
};
exports.default = (0, react_1.memo)(ContextMenu);
